import { useDispatch } from 'react-redux'
import { Outlet, useLocation } from 'react-router'

import { FloatingButton, NavigationWrapper, OutletWrapper, Search, TableExportColumns, TOAST_TYPE } from '@base'
import { DRAWER_TYPES, searchFilter, strings } from '@constants'
import { toggleDrawer } from '@data/state/action/root'
import { SearchWrapper } from './styles'
import { GetApp } from '@material-ui/icons'
import { Spacings } from '@styles'
import { getAllTenderBookLeads, getAllTenderBookUsers } from '@data'
import { convertDataFile, dataArrayToCsv } from '@utils'
import { showLoader, showToast } from '@data/state/action'

const Tenderbook = () => {
	const dispatch = useDispatch()
	const { pathname, search } = useLocation()

	const isTenderMaster = pathname.includes('tender-master')
	const isTenderUsers = pathname.includes('user-list')
	const isTenderLeads = pathname.includes('leads')
	const isBidderSearch = pathname.includes('bidder-search')

	const exportHandle = () => {
		dispatch(showLoader(true))
		const searchWithoutPage = search
			?.split('&')
			.filter((item) => !item.includes('page'))
			.join('&')

		let promise, cols, fileName
		if (isTenderLeads) {
			promise = getAllTenderBookLeads({ ...searchWithoutPage, page: 0, size: 100000 })
			cols = TableExportColumns?.tenderbookLeadsColumns()
			fileName = 'tenderbook_leads_list'
		} else if (isTenderUsers) {
			promise = getAllTenderBookUsers({ ...searchWithoutPage, page: 0, size: 100000 })
			cols = TableExportColumns?.tenderbookUserListColumns()
			fileName = 'tenderbook_user_list'
		}

		promise
			.then((response) => {
				const csvData = dataArrayToCsv(cols, response.data)
				convertDataFile(csvData, fileName)
			})
			.catch((error) => {
				dispatch(showToast(true, strings('error_while_downloading'), { type: TOAST_TYPE.ERROR }))
			})
			.finally(() => {
				dispatch(showLoader(false))
			})
	}

	const clickHandler = () => {
		if (isTenderMaster) {
			dispatch(toggleDrawer(true, DRAWER_TYPES.OPEN_SEARCH_PANEL, { searchType: searchFilter.TENDERBOOK_TENDER_MASTER_FILTER }))
		} else if (isTenderUsers) {
			dispatch(toggleDrawer(true, DRAWER_TYPES.OPEN_SEARCH_PANEL, { searchType: searchFilter.TENDERBOOK_USERS_FILTER }))
		} else if (isTenderLeads) {
			dispatch(toggleDrawer(true, DRAWER_TYPES.OPEN_SEARCH_PANEL, { searchType: searchFilter.TENDERBOOK_LEADS_FILTER }))
		} else if (isBidderSearch) {
			dispatch(toggleDrawer(true, DRAWER_TYPES.OPEN_SEARCH_PANEL, { searchType: searchFilter.TENDERBOOK_BIDDER_SEARCH }))
		}
	}
	return (
		<>
			<NavigationWrapper>
				<SearchWrapper>
					{!isTenderMaster && !isBidderSearch && (
						<FloatingButton
							desktopLabel={strings('export')}
							mobileLabel={<GetApp fontSize='medium' />}
							onClick={exportHandle}
							small
							margin={`0 ${Spacings.SPACING_2B} 0 auto`}
						/>
					)}
					<Search clickHandler={clickHandler} />
				</SearchWrapper>
			</NavigationWrapper>
			<OutletWrapper>
				<Outlet />
			</OutletWrapper>
		</>
	)
}

export default Tenderbook
